import { ReactElement } from "react";

import { CampaignContactAudienceImportArgs } from "~frontend/__generated__/graphql";

import { CampaignForEditor } from "../../types";
import AudienceTargeting from "./AudienceTargeting";

export default function AudienceImport({
  campaign,
  previousJobArgs,
  readOnly,
}: {
  campaign: CampaignForEditor;
  previousJobArgs: CampaignContactAudienceImportArgs;
  readOnly?: boolean;
}): ReactElement {
  const previousJobFilters = previousJobArgs?.filter || null;

  const previousAudienceId = previousJobArgs?.audienceId || null;

  return (
    <AudienceTargeting
      campaign={campaign}
      previousJobFilters={previousJobFilters}
      previousAudienceId={previousAudienceId}
      readOnly={readOnly}
    />
  );
}
